export default (axios, baseURL) => async () => {
  const url = `/v2/users/logout-legacy-idp`;
  const axiosConfig = {
    method: 'POST',
    baseURL,
    url,
    skipAuthLogout: true
  };
  try {
    const axiosResponse = await axios(axiosConfig);
    return axiosResponse.data;
  } catch (apiErr) {
    if (apiErr.response.status === 401) {
      console.error('User is not authenticated or logged out');
      return;
    }
    throw apiErr;
  }
};
